export const PageText = {
  _1: 'What about long term effect of air pollution?',
  _2: 'Long term effects of air quality are important. aircheckr can help you out!'
};

export const Categories = {
  _1: {
    title: 'Why long term?',
    subcategories: [
      {
        key: 0,
        subtitle: 'Both short-term and long-term effects are important',
        text: 'People experience a wide range of health effects from being exposed to air pollution. Effects can be broken down into short-term effects and long-term effects. While during a few hours of bad air quality direct actions can be taken, long-term bad air are often more difficult to counter.'
      },
      {
        key: 1,
        subtitle: 'aircheckr can help',
        text: 'aircheckr provides the yearly air quality information you need when people e.g. buy a house or choose a new school for their kids.'
      }
    ]
  },
  _2: {
    title: 'aircheckr statistics',
    subcategories: [
      {
        key: 0,
        subtitle: 'Long term Air Quality Index',
        text: 'The aircheckr Long Term AQI gives a health-based indication on the quality of the air. You can choose for the AQI rated at 3, 10 or 100. It also provides a “quality name” and “colour”. You can find more info about the long term AQI below.'
      },
      {
        key: 1,
        subtitle: 'Main long term pollutant(s)',
        text: 'What are the main long term pollutants responsible for current long term air quality index?'
      },
      {
        key: 2,
        subtitle: 'Source information',
        text: 'We give you specific information about the possible source of the main long term pollutant.'
      },
      {
        key: 3,
        subtitle: 'Number of yearly bad days',
        text: 'Besides the long term AQI, the number of bad days in a year is a good indication of the long term air quality for a location. A day is classified as bad if at least one of the four pollutants is over the given threshold. NO<sub>2</sub>, PM10 - 50μg/m<sup>3</sup>, PM2.5 - 25μg/<sup>m3</sup>, O<sub>3</sub> - 100μg/m<sup>3</sup>.'
      },
      {
        key: 4,
        subtitle: 'Percentiles',
        text: 'To be complete we also offer you the percentiles (p10 - p90) of each of the four pollutants and AQI101. '
      }
    ]
  },
  _3: {
    title: 'Long term AQI',
    subcategories: [
      {
        key: 0,
        subtitle: 'Easily interpretable',
        text: 'The aircheckr Long Term Air Quality Index (AQI) translates the complex set of AQ statistics from the different pollutants to an easily interpretable value. Just like the short term AQI, The Long Term AQI provides you with one value, one quality name and a colour. The higher the score, the healthier the air!',
        text_2: 'This aircheckr Long Term AQI is also completely health-based and hence independent of politically set thresholds. It is based on three pollutants NO<sub>2</sub>, PM10 and PM2.5.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/what-with-long-term-effect_page.js